<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G H Raisoni Memorial Buldhana District Badminton Championship  </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>G H Raisoni Memorial Buldhana District Badminton Championship </h2>
        </div>
        <p class="card-text">BULDHANA, June 17, 2024 – The G H Raisoni Memorial Buldhana District Badminton Championship took place on June 16 and 17, 2024, at the Indoor Sports Facility in Malkapur, drawing participants from across the district. The two-day tournament saw players competing fiercely across various categories, showcasing their skills and determination. The event fostered an atmosphere of intense competition and sportsmanship, with both seasoned athletes and rising stars making their mark.</p>
        <p>With a well-organized setup, the championship provided a fantastic platform for talent to shine, contributing to the growing badminton culture in the region. The tournament was hailed as a grand success, further encouraging young players to pursue the sport at higher levels.
        </p>
        <p>The championship concluded with an exciting display of emerging talent and established players, marking a significant milestone in the region’s badminton scene.</p>
        <p>The full results of the tournament have been made available in the form of a PDF for reference.</p>
        <div class="row">
            <!-- <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="media#media_classical"   class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://drive.google.com/file/d/1069W9_-cBzrBgwDIuB6IXFrKgo9RUBHC/preview"   frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                </div>
            </div> -->


            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Results</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <!-- <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a> -->
                        </div>
                    </div>
                    <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/bul-dist-final-results.pdf" height="250"
                        width="100%"></iframe>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <!-- <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a> -->
                        </div>
                    </div>
                    <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/buldhana-badminton-tournament-media.pdf" height="250"
                        width="100%"></iframe>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <!-- <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a> -->
                        </div>
                    </div>
                    <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/buldhana-badminton-tournament-images.pdf" height="250"
                        width="100%"></iframe>
                </div>
            </div>

        </div>
    </div>
</section>
